import { useParams } from 'react-router-dom';
import { Route, Routes } from 'react-router';
import buildAccess from 'src/permission/buildAccess';
import PermissionRoute from 'src/permission/permissionRoute';
import { travelTypeObject } from 'src/enumeration';
import Enum from './enum';
import List from './List';
import Add from './Add';

const DispatchDate = () => {
  const urlParams = useParams();
  const access = buildAccess(Enum.routes.name, travelTypeObject[urlParams.type]?.type);

  return (
    <Routes>
      <Route
        path={`${Enum.routes.add}`}
        element={<PermissionRoute element={<Add access={access} />} permissions={access?.create} />}
      />
      <Route
        path={`${Enum.routes.edit}/:id`}
        element={<PermissionRoute element={<Add access={access} />} permissions={access?.update} />}
      />
      <Route
        path={`${Enum.routes.list}`}
        element={<PermissionRoute element={<List access={access} />} permissions={access?.read} />}
      />
    </Routes>
  );
};

export default DispatchDate;
